export default __webpack_public_path__ + "static/media/player-list-add.ccfd78d0.svg";